const Fonts = {
	barlow: 'barlow',
	barlowMedium: 'barlow-medium',
	barlowBold: 'barlow-bold',
	barlowItalic: 'barlow-italic',
	ptSerif: 'pt-serif',
	code128: 'code128',
	ean13: 'ean13',
	webInputStack: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
};

export default Fonts;
